<template>
    <v-card>
        <v-app-bar flat dark color="primary">
            <v-toolbar-title>DATOS DE ENVÍO — Ticket {{ datos.id }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeModal">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-app-bar>
        <v-card-text class="pa-0">
            <DatosEnvio />
        </v-card-text>
    </v-card>
</template>
<script>
import { mapState } from 'vuex'
import DatosEnvio from '@/components/reservas/DatosEnvio'

export default {
    components: { DatosEnvio },
    computed: {
        ...mapState('ventas', ['datos'])
    },
    methods: {
        closeModal() {
            this.$store.commit('ventas/SHOW_MODAL_DATOS_ENVIO', false)
        }
    }
}
</script>
